import { render, staticRenderFns } from "./SpinLoader.vue?vue&type=template&id=b5e0f0b6&scoped=true&"
import script from "./SpinLoader.vue?vue&type=script&lang=js&"
export * from "./SpinLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e0f0b6",
  null
  
)

export default component.exports